

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n  ", h('path', {"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.546 0H2.454A2.457 2.457 0 0 0 0 2.454v13.09A2.458 2.458 0 0 0 2.454 18h13.091C16.9 18 18 16.9 18 15.546V2.456A2.458 2.458 0 0 0 15.546 0Zm.817 2.454v2.703h-4.09v-3.52h3.272c.45 0 .818.366.818.817ZM9 5.727A3.276 3.276 0 0 1 12.273 9 3.275 3.275 0 0 1 9 12.272 3.275 3.275 0 0 1 5.728 9 3.275 3.275 0 0 1 9 5.727Zm6.546 10.637H2.457a.819.819 0 0 1-.818-.818V7.322h2.756A4.87 4.87 0 0 0 4.092 9a4.915 4.915 0 0 0 4.909 4.91A4.915 4.915 0 0 0 13.911 9c0-.795-.194-1.542-.53-2.207h2.984v8.752a.819.819 0 0 1-.818.818","fill":"#0A3942"}, []), "\n"]);
};

        